<template>
  <div class="applicaion-wrapper">
    <!-- Content Main -->
    <div class="content" :class="{ collapsed: !application.title }">
      <content-main
        ref="contentMain"
        :application="application"
        :devices="devices"
        @tableRowClicked="tableRowClicked"
        @deviceDetailRequested="deviceDetailRequested"
        @alertsOnMapClicked="alertsOnMapClicked"
        @unselectItem="unselectApplicationAndDevices"
      ></content-main>
    </div>
    <!-- Sidebar Map -->
    <div class="sidebar-right" :class="{ visible: detailViewVisible }">
      <div
        class="mobileSwipe"
        @click="detailViewVisible = !detailViewVisible"
      ></div>
      <div class="mobileMapArea">
        <div class="sidebar-right-top">
          <div @click="detailViewVisible = !detailViewVisible">
            <span class="close__circle" style="margin-right: 12px;">x</span>
          </div>
        </div>
        <div class="sidebar-right-main">
          <indoor-navigation
            ref="indoorNavigation"
            :markers="devicesForMapMarkers"
            :mapStyle="mapStyle"
            :application="application"
          ></indoor-navigation>
        </div>
        <div
          class="sidebar-right-bottom"
          @click="detailViewVisible = !detailViewVisible"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentMain from "./contentMain";
import IndoorNavigation from "./ui-elements/indoorNavigation";

export default {
  name: "Application",
  components: {
    ContentMain,
    IndoorNavigation
  },
  data() {
    return {
      applications: this.$store.state.applications,
      devicesForMapMarkers: this.$store.state.devicesForMapMarkers,
      detailViewVisible: false,
      noDevicesFound: false,
      applicationId: null,

      mapStyle: "mapbox://styles/mapbox/streets-v9"
    };
  },
  computed: {
    application() {
      return this.loadApplication(this.$route.params.id);
    },
    devices() {
      return this.$store.state.devices;
    }
  },
  /*updated() {
    console.log("update", this.$route.params.id, this.applicationId);
    //if (this.$route.params.id && this.applicationId) {
      if (this.applicationId != this.$route.params.id) {
        this.$bus.emit("fetchApplicationDevices", this.$route.params.id);
        this.applicationId = this.$route.params.id;
      }
    //}
  },*/
  created() {
    this.$bus.on("tableRowClicked", this.tableRowClicked);
  },
  methods: {
    tableRowClicked(row) {
      this.devicesForMapMarkers = [];
      this.devicesForMapMarkers.push(row);
      this.detailViewVisible = true;
    },
    deviceDetailRequested(row) {
      this.devicesForMapMarkers = [];
      this.devicesForMapMarkers.push(row);
      this.detailViewVisible = true;
    },
    alertsOnMapClicked(data, showMap = true) {
      this.devicesForMapMarkers = [];
      data.forEach(device => {
        this.devicesForMapMarkers.push(device);
      });
      if (showMap) {
        this.detailViewVisible = true;
      }
    },
    unselectApplicationAndDevices() {
      this.$store.state.application = {};
      this.$store.state.devices = [];
      this.detailViewVisible = false;
      this.$bus.emit("unselectApplicationAndDevices");
    },
    loadApplication(applicationId) {
      let application = this.applications.find(
        a => a.id === Number(applicationId)
      );
      return application;
    }
  }
};
</script>
